<template>
    <!-- Wrapper that centers the spinning image -->
    <div class="spinner-logo d-flex align-center justify-center">
      <v-img
        :src="logoSrc"
        :alt="altText"
        max-width="80"
        max-height="80"
        class="spin-animation"
      />
    </div>
  </template>

  <script>
  export default {
    name: 'SpinnerLoader',
    props: {
      logoSrc: {
        type: String,
        default: () => require('@/assets/spinner-logo.png'),
      },
      altText: {
        type: String,
        default: 'Spinning Laurel Logo',
      },
    },
  };
  </script>

  <style scoped>
  /* Just in case you want it smaller or bigger, adjust max-width or transform */
  .spinner-logo {
    display: inline-block; /* or block, depending on your usage */
  }

  /* The spinning animation */
  .spin-animation {
    animation: spin 1.5s linear infinite;
	transform-origin: center center;
  }

  /* Keyframes for rotation */
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  </style>
